
function ExperienceDatabase() {
    return [
        {
            "logo": "/rehabilitujemy-logo.svg",
            "company": "Rehabilitujemy",
            "position": "Co-Founder / Engineer",
            "team": "Co-Founder",
            "dates": "Mar 2025 - Present",
            "summary": "Created a Physiotherapy Clinic with focus on technical infrastructure and digital marketing",
            "paragraphs": [
                "Created a Physiotherapy Clinic where my co-founder responsibilities were mostly technical to make the best of my skillset.",
                "Built a website for the clinic and worked on SEO optimizations to increase online visibility.",
                "Built a blogging system with PayloadCMS and created analytics conversion tracking with PostHog.",
                "Worked on Meta Ads and Google Ads campaigns to attract new patients.",
                "Created automations for customers so they get proper messages on their phone/email based on various actions like: sending us a form, reserving a visit in a clinic, after a visit message etc."
            ],
            "technologies": [
                "NextJS",
                "PayloadCMS",
                "React",
                "PostHog",
                "n8n"
            ],
            "color": "rgba(76, 175, 80, 0.2)",
            "textColor": "#4caf50",
            "messeges": [
                "Rehabilitujemy is our physiotherapy clinic that combines healthcare with modern technology!",
                "As a co-founder, I focus on the technical side - building websites, setting up analytics, and creating automations.",
                "It's amazing how technology can improve patient experience and clinic operations!",
                "We use modern tools like PostHog for analytics and n8n for customer communication automations.",
                "The goal is to provide the best physiotherapy services while using technology to streamline everything!"
            ]
        },
        {
            "logo": "/is-logo.png",
            "company": "Invest Smart",
            "position": "Co-Founder / Engineer",
            "team": "Co-Founder",
            "dates": "Feb 2024 - Present",
            "summary": "Investment company where investors entrust us with their money to invest into real estate, businesses and stock market",
            "paragraphs": [
                "Investors entrust us with their money to invest into real estate, other businesses and the stock market. As a co-founder, I was responsible for technical part of the business.",
                "Built a landing page and a scraping service that scrapes tens of thousands real estate listings from Polish websites.",
                "Built API that uses scraped data for our internal tools and web tools like investment calculator that can be used for free on InvestSmart website.",
                "Built chrome extension SmartKW that allows for better experience when working with government land and mortgage register."
            ],
            "technologies": [
                "NextJS",
                "NodeJS",
                "RabbitMQ",
                "Javascript",
                "PostgreSQL"
            ],
            "color": "rgba(255, 193, 7, 0.2)",
            "textColor": "#ffc107",
            "messeges": [
                "Invest Smart is where we help people grow their wealth through smart investments!",
                "As a co-founder, I handle all the technical infrastructure - from web scraping to building tools.",
                "We scrape tens of thousands of real estate listings to find the best investment opportunities!",
                "Our chrome extension SmartKW makes working with government property registers much easier.",
                "It's exciting to build technology that helps people make better investment decisions!"
            ]
        },
        {
            "logo": "/atlassianmark.svg",
            "company": "Atlassian",
            "position": "Software Engineer",
            "team": "Jira Cloud Search",
            "dates": "Sep 2023 - Sep 2024",
            "summary": "Backend development of Jira Cloud Search systems",
            "paragraphs": [
                "Development of backend systems for Jira Cloud Search, that provides search functionality for Jira Cloud.",
                "Implemented new storage solution with Elasticsearch, that improved search performance.",
                "Created multiple dashboards that provide insights into search performance and user behavior.",
            ],
            "technologies": [
                "Java",
                "Kotlin",
                "Python",
                "Elasticsearch"
            ],
            "color": "rgba(25,118,210, 0.2)",
            "textColor": "#1976d2",
            "messeges": [
                "Atlassian is a company that develops software for software development!",
                "The main campus is in Sydney, Australia, but I work in Gdansk, Poland!",
                "I work on Jira Cloud Search, where we develop search systems for Jira Cloud!",
                "It's a great place to work, with a lot of opportunities to learn and grow!",
            ]
        },
        {
            "logo": "/fblogo.png",
            "company": "Facebook",
            "position": "Software Engineer",
            "team": "Identity and Access Management",
            "dates": "October 2020 - Sep 2023",
            "summary": "Fullstack development of internal tools and backend system",
            "paragraphs": [
                "Worked on backend systems for all employees, that registers proper accounts and provides access to relevant tools.",
                "Improved performance of core system, that helped prevent employees from not getting access on work start date.",
                "Developed internal tool to evaluate policies based on client requirements and returns obligations.",
                "Created E2E Testing Framework for core system, to provide better testability, stability and reliability."
            ],
            "technologies": [
                "Python",
                "PHP/HACK",
                "Javascript",
                "React",
                "SQL"
            ],
            "color": "rgba(25,118,210, 0.2)",
            "textColor": "#1976d2",
            "messeges": [
                "Facebook is such a cool place to work at!",
                "All the work and projects I've done were really interesting 😁",
                "but I have to say, the infrastructure of Facebook is crazy, and I really value this experience!",
                "Cooperation between teams is fantastic, where each team is like a separate small company 😳",
                "and the experience of working on services, that process big chunks of data and are used by tens of thousands of people...",
                "is something that I really loved and wanna keep doing!"
            ]
        }, 
        // {
        //     "logo": "https://res-4.cloudinary.com/crunchbase-production/image/upload/c_lpad,h_256,w_256,f_auto,q_auto:eco/qg8ghau9o27dex7cmoxd",
        //     "company": "Gforces",
        //     "position": "Software Engineer",
        //     "team": "Website Builder Tool",
        //     "dates": "August 2020 - October 2020",
        //     "summary": "Worked on backend system, that provides website builder for our clients from Automotive industry",
        //     "paragraphs": [
        //         "Worked on backend system, that provides website builder for clients from Automotive industry.",
        //         "Developed widgets, that are used in website builder.",
        //         "Worked on bug fixes and maintance.",
        //     ],
        //     "technologies": [
        //         "Python",
        //         "PHP/HACK",
        //         "Javascript",
        //         "React",
        //         "SQL"
        //     ],
        //     "color": "rgba(25,118,210, 0.2)",
        //     "textColor": "#1976d2",
        //     "messeges": [
        //         "Gforces was the next step of my journey!",
        //         "I had a chance to work with automotive again, this time developing website builder for car dealerships mostly in UK!",
        //         "The team was great, and in this place I understood how much you can do with technology...",
        //         "And how many solutions there are in IT world, each leads to different product requirments, which can be performance, scalability or anything you can imagine!",
        //     ]
        // },
        {
            "logo": "/motorcentrumlogo.png",
            "company": "Motor Centrum",
            "position": "Software Engineer",
            "team": "Engineering team",
            "dates": "May 2020 - August 2020",
            "summary": "Internal tools development for Business Development Center",
            "paragraphs": [
                "Full Stack development of internal tool for Business Development Center to improve the way in which they manage data.",
                "Developed Website for new service offered by the company. Vintage cars."
            ],
            "technologies": [
                "Python",
                "PHP/HACK",
                "Javascript",
                "React",
                "SQL"
            ],
            "color": "rgba(25,118,210, 0.2)",
            "textColor": "#1976d2",
            "messeges": [
                "Hey! Motor Centrum is a car dealership from Poland",
                "they also deal with Harleys, so maybe it is a car/motorcycle company 😅",
                "it was the first time I worked in bigger company, that taught me not only new programming skills...",
                "but also how different sectors from company operate together!",
            ]
        },
        {
            "logo": "/flywider.png",
            "company": "Flywider",
            "position": "Software Engineer",
            "team": "Engineering team lead",
            "dates": "September 2019 - May 2020",
            "summary": "Advertisement campaign platform development for companies and influencers",
            "paragraphs": [
                "Development of Web Application for companies to create advertisement campaign with influencers from various platforms like Youtube, Instagram and Tiktok",
                "Lead the team of three people to create platform from scratch with great perfromance and organized code.",
                "Created UI from scratch based on provided design",
                "Run meetings with stakeholders and programmers",
                "Developed OneRank - custom ranking algorithm, that uses external API and calculated the score for influencer"
            ],
            "technologies": [
                "PHP",
                "Laravel",
                "Javascript",
                "React",
                "SQL",
                "Git"
            ],
            "color": "#4c174d",
            "textColor": "#6f4570",
            "messeges": [
                "In Flywider I was given an opportity to create Influencer Advertisement Platform from scratch 😎",
                "As I had experience with the company from my work in Apollin, I took this opportunity and...",
                "lead the team of 3 people!",
                "Great experience, that gave me a new understanding of how to manage the project from different perspectives.",
                "Oh almost forgot! Here are some links:",
                "https://flywider.net/",
                "https://platform.flywider.net/",
            ]
        },
        {
            "logo": "https://i.ibb.co/F8dT4mB/1620159759467-Logo-Apollin1.png",
            "company": "Apollin",
            "position": "Software Engineer",
            "team": "Web Development",
            "dates": "March 2019 - September 2020",
            "summary": "Website development and maintenance with technologies such as PHP, Wordpress and React",
            "paragraphs": [
                "Development of Wordpress based custom Web Applications for clients from all over the world",
                "Performance development focus to handle thousands of active users",
                "Custom Theme development based on provided designs",
            ],
            "technologies": [
                "PHP",
                "Wordpress",
                "Laravel",
                "Javascript",
                "React",
                "SQL"
            ],
            "color": "#4d5053",
            "textColor": "#4d5053",
            "messeges": [
                "Apollin is the place where my carrer began!",
                "I was lucky enough to work with my colleague on freelancing projects and get real world experience 😳",
                "The best part about this, is that there were thousands of live users on the websites I worked on...",
                "this gave me an opportunity to focus on performance/caching etc. 😁",
                "pss... Checkout those websites I worked on",
                "https://dartsnews.com/",
                "https://tennisuptodate.com/",
            ]
        },
    ]
}

export default ExperienceDatabase;
